import { Box } from "@mui/material";
import { useEffect } from "react";
import { useLocation, useParams } from 'react-router-dom';
import { PlaidLinkButtonComponent } from "./PlaidLinkComponent";
import { PlaidDeclineButton } from "./PlaidDeclineButton";
import { useCreateLinkToken } from "../../../../logic/useApiQuery";
import { useNotificationContentOverride } from "../../../context/notification-content-override/NotificationContentOverrideContext";
import { track } from "../../../../logic";
import { ErrorDialog } from "../../dialogs/ErrorDialog";

const PLAID_URL = 'https://support-my.plaid.com/hc/en-us/articles/4410327486615-Who-is-Plaid'
const PLAID_CONTENT_TEXT = `We couldn’t verify your bank account with the information provided. This is common and can happen for a variety of reasons. To proceed, please complete bank verification through <a href="${PLAID_URL}" target="_blank" rel="noopener noreferrer">Plaid</a>. This step helps prevent wire fraud and ensures your account details are confirmed safely and securely.`

export function PlaidComponent() {
  const { search } = useLocation()
  const { closingId, id } = useParams()

  const createLinkTokenRequest = useCreateLinkToken(closingId ?? '', id ?? '', search)

  const { setNotificationContentOverride } = useNotificationContentOverride();
  useEffect(() => {
    setNotificationContentOverride(PLAID_CONTENT_TEXT)
  }, [setNotificationContentOverride])

  //TODO: Either make this a common method or use some sort of global toast so that the toast could get populated inside of the onError in the useQuery
  if (createLinkTokenRequest.isError) {
    track('error', 'fetching data for account verification', {}, {
      message: JSON.stringify({
        createLinkToken: createLinkTokenRequest.error,
      }),
      component: 'AccountVerificationTask',
    })
    return <ErrorDialog error='There was an error processing your request.' tryAgainText='Reload and try again' />
  }

  const linkTokenData = createLinkTokenRequest.data
  if (linkTokenData) {
    return (
      <Box sx={{ p: 2, display: 'flex', flexDirection: 'column', gap: 2 }}>
        <PlaidLinkButtonComponent linkToken={linkTokenData.linkToken} />
        <PlaidDeclineButton />
      </Box >
    )
  } else {
    return (
      null
    )
  }
}
